export default __webpack_public_path__ + "static/figure_mission-e7b3bfd7bdb96a2fc541dc493afdf414.mp4";